import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import CardWidgetSelectDropdownWithErrors from "../../card-widget/error-card-widgets/CardWidgetSelectDropdownWithErrors";

class ValidateableDropdownField extends Component {
  constructor(props) {
    super(props);
    this.validateValue({target: {value: ''}});
  }

  validateValue = (e) => {
    this.errorMessage = this.props.validationFunction(e.target.value);
    this.props.onChange(e, this.errorMessage);
  };

  onChange = (e) => {
    this.validateValue(e);
  };

  render() {
    this.errorMessage = this.props.customError ? this.props.customError : this.errorMessage;
    if (this.props.showErrors) {
      return (
          <CardWidgetSelectDropdownWithErrors
              options={this.props.options}
              customOptions={this.props.customOptions}
              fieldLabel={this.props.fieldLabel}
              onChange={this.onChange}
              errorMessage={this.errorMessage}
          />
      );
    } else {
      return (
          <CardWidgetSelectDropdownWithErrors
              options={this.props.options}
              customOptions={this.props.customOptions}
              fieldLabel={this.props.fieldLabel}
              onChange={this.onChange}
              errorMessage=''
          />
      );
    }
  }
}

ValidateableDropdownField.propTypes = {
  validationFunction: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldLabel: PropTypes.string,
  showErrors: PropTypes.bool,
  customError: PropTypes.string,
  options: PropTypes.string,
  customOptions: PropTypes.array
};

export default ValidateableDropdownField;

